import React from "react";
import { StyledModal, Title, SubTitle, Frame } from "./styles/confirm";
import { ModalProps } from "antd";
import { scrim } from "src/theme/ui";
import { Button, DialogActions, DialogMark } from "src/components/ui";

interface IConfirmModal extends ModalProps {
  onConfirm?: () => void;
  onCancel?: () => void;
  buttonLoading?: boolean;
}

const Confirm = ({
  buttonLoading,
  onConfirm,
  onCancel,
  ...rest
}: IConfirmModal) => {
  return (
    <StyledModal
      wrapClassName="fina-dialog"
      maskStyle={{ background: scrim, backdropFilter: "none" }}
      centered
      closable={false}
      /* The scrim backs out. `onCancel` went to the button and never to the
         dialog, so there was no way out but a button. */
      onCancel={onCancel}
      width={480}
      /* One row, quiet choice first. These were stacked in a half-width
         column with the destructive one on top and the safe one drawn as the
         loud blue button under it. */
      footer={[
        <DialogActions key="customAction">
          <Button variant="secondary" size="lg" onClick={onCancel}>
            Keep order
          </Button>
          <Button
            variant="destructiveSolid"
            size="lg"
            onClick={onConfirm}
            loading={buttonLoading}
          >
            Cancel order
          </Button>
        </DialogActions>,
      ]}
      {...rest}
    >
      <Frame>
        <DialogMark tone="danger" />
        {/* "Yes, I'm Sure" / "No, Go Back" against "are you sure you want to
            cancel this Order?" asks the reader to unpick a double negative —
            cancelling a cancellation. The buttons name the outcomes. */}
        <Title>Cancel this order?</Title>
        <SubTitle>This cannot be undone.</SubTitle>
      </Frame>
    </StyledModal>
  );
};

export default Confirm;
